import { useRef, type RefObject } from 'react';
import { useIntersectionObserver } from 'hooks/useIntersectionObserver';

interface UseDialogShadowOptions {
    headerHeightFallback?: number;
    footerHeightFallback?: number;
    headerMarginOffset?: number;
    footerMarginOffset?: number;
}

export const useDialogShadow = (options: UseDialogShadowOptions = {}) => {
    const {
        headerHeightFallback = 80,
        footerHeightFallback = 120,
        headerMarginOffset = 30,
        footerMarginOffset = 32,
    } = options;

    const modalRef: RefObject<HTMLDivElement | null> = useRef<HTMLDivElement | null>(null);
    const headerRef: RefObject<HTMLDivElement | null> = useRef<HTMLDivElement | null>(null);
    const footerRef: RefObject<HTMLDivElement | null> = useRef<HTMLDivElement | null>(null);

    const { ref: topShadowTriggerRef, isIntersecting: isHeaderIntersecting } = useIntersectionObserver({
        threshold: 0,
        rootMargin: `-${(headerRef.current?.clientHeight || headerHeightFallback) + headerMarginOffset}px 0px 0px 0px`,
        root: modalRef.current,
    });

    const { ref: bottomShadowTriggerRef, isIntersecting: isFooterIntersecting } = useIntersectionObserver({
        threshold: 0,
        rootMargin: `0px 0px -${Math.abs((footerRef.current?.clientHeight || footerHeightFallback) - footerMarginOffset)}px 0px`,
        root: modalRef.current,
    });

    return {
        modalRef,
        headerRef,
        footerRef,
        topShadowTriggerRef,
        bottomShadowTriggerRef,
        isHeaderIntersecting,
        isFooterIntersecting,
    };
};
